<template>
    <program-sponsors-list routeName="employee-teach-sponsor-details"></program-sponsors-list>
</template>

<script>
import ProgramSponsorsList from '@/views/Employee/ProgramComponents/ProgramDetails/ProgramSponsors/ProgramSponsorsList.vue'

export default {
    name: "TeachSponsorList",
    components: {ProgramSponsorsList  },
    data: () => ({})
}
</script>